export const urls = {
  generateOrderPdf: () => `/api/client/v1/pdfs/orders/`,
};
